import type { RouterConfig } from '@nuxt/schema';
import { useAppConfig } from '#app/config';
import { appendInitialSpaceRoutes } from '#layers/spaces/public';
import { reservedSlugs } from '#shared/constants/reserved';

export const resolveInitialStudioRoutes: NonNullable<RouterConfig['routes']> = async (studioRoutes) => {
	try {
		// Get workspace slug from the URL
		const [_, workspaceSlug] = window.location.pathname.split('/');

		if (workspaceSlug && !reservedSlugs.includes(workspaceSlug)) {
			const appConfig = useAppConfig();
			appConfig.monospace.workspaceSlug = workspaceSlug;

			return await appendInitialSpaceRoutes(studioRoutes);
		}
	}
	catch (error) {
		console.error('Error fetching spaces:', error);
	}

	return studioRoutes;
};
